<mat-card>
  <mat-card-content>
    <mat-card-subtitle>TFG Account Management</mat-card-subtitle>
    <p>Enter or scan a valid TFG card below</p>
    <form class="dynamic-form" [formGroup]="form" style="width: 100%">
      <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

        <mat-form-field fxFlex="40" width="100%">
          <mat-label>Store</mat-label>
          <mat-select formControlName="storeId">
            <mat-option *ngFor="let store of stores" [value]="store.storeId">
              {{store.storeName}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex="40" width="100%">
          <mat-label>TFG Card Number</mat-label>
          <input matInput style="text-align: left;" type="text" min="19" max="19" formControlName="tfgCardNumber"
            autocomplete="new-password" (keyup.enter)="checkForTfgCardScan($event, $event.target.value)">
        </mat-form-field>

        <div fxFlex="10" width="100%">
          <button mat-raised-button color="primary" [disabled]="!form.valid || tfgAccountDetails"
            (click)="validate()">Search</button>
        </div>

        <div fxFlex="10" width="100%">
          <button mat-raised-button color="primary" [disabled]="!tfgAccountDetails" (click)="reset()">Reset</button>
        </div>

      </div>
    </form>
  </mat-card-content>
  <mat-card-actions align="start">
    <button mat-button (click)="openTfgCustomerPortal()">Launch TFG Customer Portal</button>
    <button mat-button (click)="openTfgNewAccountPortal()">Launch TFG DAS Portal</button>
    <button mat-button (click)="openTfgCardReplenPortal()">Launch TFG Card Replen Portal</button>
  </mat-card-actions>
</mat-card>

<ng-container *ngIf="tfgAccountDetails">

  <mat-card class="account-message" *ngIf="tfgAccountDetails.canSell === false" style="margin-top: 16px;">
    <mat-card-content>
      This account is not allowed to make a sale, please contact TFG Customer Services - 0860 834 834
    </mat-card-content>
  </mat-card>

  <mat-card class="account-message" *ngIf="tfgAccountDetails.canPay === false" style="margin-top: 16px;">
    <mat-card-content>
      This account is not allowed to make a payment, please contact TFG Customer Services - 0860 834 834
    </mat-card-content>
  </mat-card>


  <mat-card style="margin-top: 16px;">
    <mat-card-content>
      <div style="width: 100%;" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="16px">
        <div fxFlex="35">
          <mat-card-subtitle>Account Details</mat-card-subtitle>
          <table style="width: 100%;">
            <tr>
              <th class="th-label" style="min-width: 90px;">Acc. Status</th>
              <td class="td-value">{{tfgAccountDetails.accountStatus}}</td>
            </tr>
            <tr>
              <th class="th-label">Acc. Type</th>
              <td class="td-value">{{tfgAccountDetails.accountType}}</td>
            </tr>
            <tr>
              <th class="th-label">Title</th>
              <td class="td-value">{{tfgAccountDetails.title}}</td>
            </tr>
            <tr>
              <th class="th-label">Initials</th>
              <td class="td-value">{{tfgAccountDetails.initials}}</td>
            </tr>
            <tr>
              <th class="th-label">Surname</th>
              <td class="td-value">{{tfgAccountDetails.surname}}</td>
            </tr>
            <tr>
              <th class="th-label">Is Primary</th>
              <td class="td-value">{{tfgAccountDetails.isPrimary ? 'Yes' : 'No'}}</td>
            </tr>
            <tr>
              <th class="th-label">Can Pay</th>
              <td class="td-value">{{tfgAccountDetails.canPay ? 'Yes' : 'No'}}</td>
            </tr>
            <tr>
              <th class="th-label">Can Sell</th>
              <td class="td-value">{{tfgAccountDetails.canSell ? 'Yes' : 'No'}}</td>
            </tr>
          </table>
        </div>
        <div fxFlex="35">
          <mat-card-subtitle>&nbsp;</mat-card-subtitle>
          <table style="width: 100%;">
            <tr>
              <th class="th-label">OTB</th>
              <td class="td-value" style="text-align: right;">{{tfgAccountDetails.openToBuyAmount | number:'1.2-2'}}
              </td>
            </tr>
            <tr>
              <th class="th-label">Acc. Balance</th>
              <td class="td-value" style="text-align: right;">{{tfgAccountDetails.accountBalanceAmount |
                number:'1.2-2'}}
              </td>
            </tr>
            <tr>
              <th class="th-label">Instalment</th>
              <td class="td-value" style="text-align: right;">{{tfgAccountDetails.accountInstalmentAmount |
                number:'1.2-2'
                : ''}}</td>
            </tr>
            <tr>
              <th class="th-label">Arrears</th>
              <td class="td-value" style="text-align: right;">{{tfgAccountDetails.totalArrearsAmount | number:'1.2-2' :
                ''}}</td>
            </tr>
            <tr>
              <th class="th-label">Total Due</th>
              <td class="td-value" style="text-align: right;">{{tfgAccountDetails.totalDueAmount | number:'1.2-2' : ''}}
              </td>
            </tr>
            <tr>
              <th class="th-label">Credit Limit</th>
              <td class="td-value" style="text-align: right;">{{tfgAccountDetails.totalCreditlimit | number:'1.2-2' :
                ''}}
              </td>
            </tr>
            <tr>
              <th class="th-label">Discount %</th>
              <td class="td-value" style="text-align: right;">{{tfgAccountDetails.maximumDiscountPercentage |
                number:'1.2-2' : ''}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div fxFlex="35">
        <mat-card-subtitle>Credit Plans</mat-card-subtitle>
        <mat-list dense>
          <mat-list-item *ngFor="let plan of tfgAccountDetails.creditPlans"> {{plan.creditPlan}} </mat-list-item>
        </mat-list>
      </div>
    </mat-card-content>
    <mat-card-actions align="start">
      <button mat-button [disabled]="!tfgAccountDetails.canPay" (click)="payAccount('UNDIRECTED_PAYMENT')">Pay TFG Account Instalment</button>
      <!-- <button mat-button [disabled]="!tfgAccountDetails.canPay" (click)="payAccount('DEPOSIT')">Increase TFG Account OTB</button> -->
      <button mat-button (click)="openTfgCustomerPortal()">Launch TFG Customer Portal</button>
    </mat-card-actions>
  </mat-card>

  <mat-card style="margin-top: 16px;">
    <mat-card-subtitle>Account Transctions</mat-card-subtitle>
    <kendo-grid [kendoGridBinding]="transactions" [scrollable]="true" [resizable]="true" [reorderable]="true"
      [sortable]="true">

      <kendo-grid-column [width]="75" title="" class="td-action">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <button matTooltip="Generate Payment Receipt" *ngIf="dataItem.canCreateReceipt" mat-icon-button
            (click)="generateDocument(dataItem)">
            <mat-icon>post_add</mat-icon>
          </button>
          <button matTooltip="Download Payment Receipt Document" *ngIf="dataItem.canDownloadReceipt" mat-icon-button
            (click)="downloadResource(dataItem.resource)">
            <mat-icon>download</mat-icon>
          </button>
          <button matTooltip="Email Payment Receipt Document" *ngIf="dataItem.canDownloadReceipt" mat-icon-button
            (click)="emailDocument(dataItem.email)">
            <mat-icon>forward_to_inbox</mat-icon>
          </button>
          <button matTooltip="Undo TFG Account Payment" *ngIf="dataItem.canReversePayment" mat-icon-button
            (click)="reversePayment(dataItem)">
            <mat-icon>undo</mat-icon>
          </button>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="150" field="creationDate" title="Created At">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{dataItem.creationDate | date: 'MMM d, yyyy HH:mm'}}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="120" field="requestType" title="Request Type">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span class="ellipse">
            {{dataItem.requestType}}
          </span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="120" field="transactionType" title="Transaction Type">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span class="ellipse">
            {{dataItem.transactionType}}
          </span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="120" field="transactionSubType" title="Transaction Sub Type">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span class="ellipse">
            {{dataItem.transactionSubType}}
          </span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="100" field="creditPlan" title="Credit Plan">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span class="ellipse">{{dataItem.creditPlan}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="130" format="{0:n2}" class="td-number" field="transactionAmount"
        title="Transaction Amount">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="td-number">{{dataItem.transactionAmount | number:'1.2-2'}}</div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="100" field="storeName" title="Branch">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span class="ellipse">{{dataItem.storeName}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="100" field="visionAuthorizationCode" title="Auth. Code">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span class="ellipse">{{dataItem.visionAuthorizationCode}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="100" field="salesOrderNumber" title="Sales Order">
        <ng-template kendoGridCellTemplate let-dataItem>
          <a class="ellipse"
            [routerLink]="['/pos/orders/syspro/' + dataItem.salesOrderNumber]">{{dataItem.salesOrderNumber}}</a>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="100" field="invoiceNumber" title="Invoice">
        <ng-template kendoGridCellTemplate let-dataItem>
          <a class="ellipse" [routerLink]="['/pos/invoices/' + dataItem.invoiceNumber]">{{dataItem.invoiceNumber}}</a>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="100" field="createdBy" title="Created By">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span class="ellipse">{{dataItem.createdBy}}</span>
        </ng-template>
      </kendo-grid-column>

      <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="showEmailDetails">
        <div style="margin: 16px;">
          <kendo-grid [kendoGridBinding]="dataItem.emails" [scrollable]="true" [resizable]="true" [reorderable]="true"
            [sortable]="true">

            <kendo-grid-column [width]="150" field="emailType" title="Email. Type"> </kendo-grid-column>
            <kendo-grid-column [width]="200" field="sentAt" title="Sent At">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.sentAt | date: 'MMM d, yyyy HH:mm'}}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [width]="250" field="sentTo" title="Sent To"> </kendo-grid-column>
            <kendo-grid-column [width]="200" field="emailStatus" title="Email Status"> </kendo-grid-column>

          </kendo-grid>
        </div>
      </ng-template>
    </kendo-grid>
  </mat-card>
</ng-container>
